<template>
  <div>
    <!-- REMOVE - ONLY FOR DEBUG -->
    <!-- {{this.$route.query}} -->

    <div v-if="waiter === true">
      <XVwaiter></XVwaiter>
    </div>
    <div v-if="waiter === false">
      <div class="row margin20bottom" v-if="graphdata.length > 0">
        <div class="col-md-12">
          <XVgraphcontrol :graphdata="graphdata" @graphClick="graphClick"></XVgraphcontrol>
        </div>
      </div>
      <div id="pnlTitleBar">
        <span
          id="lblTitel"
          class="titel"
          :class="{ hide: wXS || wSM }"
          v-html="translation(7641)"
          v-if="$route.params.role === 'prof' || $route.params.role === 'edu'"
        ></span>
        <span
          id="lblTitel"
          class="titel"
          :class="{ hide: wXS || wSM }"
          v-html="translation(8032)"
          v-if="$route.params.role === 'beheer' && !viewProfAsAdmin"
        ></span>
        <span
          id="lblTitel"
          class="titel"
          :class="{ hide: wXS || wSM }"
          v-html="translation(12339) + ' ' + profPersonName"
          v-if="$route.params.role === 'beheer' && viewProfAsAdmin"
        ></span>
      </div>
      <div id="pnlTabLinksDossier" CssClass="tabLinksDossier" v-if="$route.params.role === 'beheer' && viewProfAsAdmin">
        <div v-if="showLinkProfDetail" id="hypProfDetail" class="row inactiveDossierLink visibileTab0adm">
          <div class="col-md-12">
            <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;
            <a :href="'/beheer/SPE393_BH_ProfDetail.aspx?id=' + profPersonId">{{ translation(334) }}</a>
          </div>
        </div>
        <div
          id="lblProfMsg"
          class="row activeDossierLink visibileTabProfMsgadm"
          v-if="showLinkStatusoverzicht || showLinkProfDetail || showLinkActiviteiten || showLinkMutatie || showLinkMSF"
        >
          <div class="col-md-12">
            <font-awesome-icon :icon="['fa', 'location-arrow']" class="fa-rotate-45" />
            &nbsp;
            {{ translation(12339) }}
          </div>
        </div>
        <div v-if="showLinkStatusoverzicht" id="hypStatusoverzicht" class="row inactiveDossierLink visibileTab1adm">
          <div class="col-md-12">
            <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;
            <a :href="'/beheer/SPE020_BH_Statusoverzicht.aspx?id=' + profPersonId">{{ translation(3510) }}</a>
          </div>
        </div>
        <div v-if="showLinkActiviteiten" id="hypActiviteiten" class="row inactiveDossierLink visibileTab2adm">
          <div class="col-md-12">
            <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;
            <a :href="'/peapp/beheer/SPE021BHPEActiviteiten/' + profPersonId + '/0'">{{ translation(3511) }}</a>
          </div>
        </div>
        <div v-if="showLinkMutatie" id="hypMutatie" class="row inactiveDossierLink visibileTab3adm">
          <div class="col-md-12">
            <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;
            <a :href="'/beheer/SPE394_BH_Mutatie.aspx?id=' + profPersonId">{{ translation(3512) }}</a>
          </div>
        </div>
        <div v-if="showLinkMSF" id="hypMSF" class="row inactiveDossierLink visibileTab4adm">
          <div class="col-md-12">
            <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;
            <!-- <a
              :href="'/allroles/multisourcefeedback/SPE696_PR_PatientEnquete_overviewV2.aspx?id='+ profPersonId"
            >{{ translation(10367) }}</a> -->
            <router-link :to="{ name: 'SPE696PatientEnquete', params: { personid: profPersonId } }">
              {{ translation(10367) }}</router-link
            >
          </div>
        </div>
      </div>
      <p>
        <span
          id="lblBeschrijving"
          v-html="translation(243)"
          v-if="$route.params.role === 'beheer' && !viewProfAsAdmin && !adminWelcomeText"
        ></span>
        <span
          id="lblBeschrijving"
          v-html="adminWelcomeText"
          v-if="$route.params.role === 'beheer' && !viewProfAsAdmin && adminWelcomeText"
        ></span>
      </p>
      <p class="HeadInfo hidden-xs">
        <span
          id="lblMededelingen"
          v-html="translation(12340)"
          v-if="$route.params.role === 'beheer' && viewProfAsAdmin"
        ></span>
        <span
          id="lblMededelingen"
          v-html="translation(1333)"
          v-if="$route.params.role === 'beheer' && !viewProfAsAdmin"
        ></span>
        <span id="lblMededelingen" v-html="translation(1335)" v-if="$route.params.role === 'prof'"></span>
      </p>
      <main class="XVtableVirtalScroll-container">
        <XVSticky class="XVtableVirtalScroll-header">
          <div class="Meldingenheader">
            <div>
              <div class="row headerbars postvakin">
                <div class="col-md-12">
                  <div class="archivetext" v-if="archiveToggle">
                    <span class="glyphicon glyphicon glyphicon-inbox"></span>&nbsp;
                    <span>{{ translation(12741) }}</span> &nbsp;
                    <span id="LblmsgcntArchive">({{ archiveCount }})</span>
                  </div>
                  <div class="inboxtext" v-if="!archiveToggle">
                    <span class="glyphicon glyphicon glyphicon-inbox"></span>&nbsp;
                    <span>{{ translation(12740) }}</span> &nbsp;
                    <span id="Lblmsgcnt">({{ inboxCount }})</span>
                  </div>
                </div>
              </div>
              <div
                id="mailapp"
                class="row mailbuttonbar"
                data-pageid="1"
                data-archive="false"
                data-searchvalue
                data-sortorder="Newestontop"
              >
                <div class="col-md-6 col-sm-6 col-xs-12 barrow searchbar">
                  <div class="input-group">
                    <input
                      type="text"
                      :value="search"
                      @input="setSearch($event.target.value)"
                      @keyup.enter="setMeldingenSearch($event.target.value)"
                      class="form-control input-sm DGSearchfield"
                      aria-describedby="Mailsearchicon"
                      :placeholder="translation(12739)"
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-default btn-sm DGSearchreset"
                        v-if="search !== ''"
                        @click="setMeldingenSearch('')"
                        type="button"
                      >
                        <span class="glyphicon glyphicon-remove"></span>
                      </button>
                      <button
                        id="butSearch"
                        @click="setMeldingenSearch(search)"
                        class="btn btn-default btn-sm DGSearch"
                        type="button"
                      >
                        <span class="glyphicon glyphicon-search"></span>
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12 barrow barbuttons">
                  <span class="btn-group" v-if="!viewProfAsAdmin">
                    <button
                      id="btnMsgSelect"
                      type="button"
                      class="btn btn-default dropdown-toggle"
                      :class="{ 'btn-xs': wXS || wSM, 'btn-sm': !wXS && !wSM }"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="glyphicon glyphicon-ok mailDDcheck"></span>
                      <span class="glyphicon glyphicon-triangle-bottom"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a @click="selectAllMeldingen()" class="pointer">{{ translation(14455) }}</a>
                      </li>
                      <li>
                        <a @click="deSelectAllMeldingen()" class="pointer">{{ translation(4844) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="selectGelezenMeldingen()">{{ translation(4845) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="selectOnGelezenMeldingen()">{{ translation(12734) }}</a>
                      </li>
                    </ul>
                  </span>
                  <span class="btn-group" v-if="!viewProfAsAdmin">
                    <button
                      id="btnMsgAction"
                      type="button"
                      class="btn btn-default dropdown-toggle"
                      :class="{ 'btn-xs': wXS || wSM, 'btn-sm': !wXS && !wSM }"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="glyphicon glyphicon-cog mailDDcheck"></span>
                      <span class="glyphicon glyphicon-triangle-bottom"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a class="pointer" @click="setArchiveMeldingen({ Archive: !archiveToggle })">
                          <span :class="archiveToggle ? 'archivetext' : 'inboxtext'">{{
                            archiveToggle ? translation(12736) : translation(12735)
                          }}</span>
                        </a>
                      </li>
                      <li>
                        <a class="pointer" @click="setReadUnreadMeldingen({ read: true })">{{ translation(12737) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="setReadUnreadMeldingen({ read: false })">{{ translation(12738) }}</a>
                      </li>
                    </ul>
                  </span>
                  <span class="btn-group">
                    <button
                      type="button"
                      class="btn btn-default dropdown-toggle"
                      :class="{ 'btn-xs': wXS || wSM, 'btn-sm': !wXS && !wSM }"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="mailSortText">{{ translation(12742) }}</span>
                      <span class="glyphicon glyphicon-filter"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a class="pointer" @click="changeSortMeldingen(0)">{{ translation(4770) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="changeSortMeldingen(1)">{{ translation(4773) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="changeSortMeldingen(2)">{{ translation(4771) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="changeSortMeldingen(3)">{{ translation(4772) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="changeSortMeldingen(4)">{{ translation(4774) }}</a>
                      </li>
                      <li>
                        <a class="pointer" @click="changeSortMeldingen(5)">{{ translation(4775) }}</a>
                      </li>
                    </ul>
                  </span>
                  <span class="btn-group">
                    <button
                      type="button"
                      @click="setToggleArchive()"
                      class="btn btn-default mailarchivebtn"
                      :class="{ 'btn-xs': wXS || wSM, 'btn-sm': !wXS && !wSM }"
                    >
                      <span class="glyphicon glyphicon glyphicon-inbox"></span>&nbsp;
                      <span class="inboxtext" v-if="!archiveToggle">{{ translation(13251) }}</span>
                      <span class="archivetext" v-if="archiveToggle">{{ translation(13252) }}</span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="Meldingenheadercolumns">
            <portal-target class="hidden-xs" name="XVtableVirtualScrollPortalhtml" slim></portal-target>
            <div class="hidden-md hidden-lg">&nbsp;</div>
          </div>
        </XVSticky>
        <div class="XVtableVirtalScroll-content">
          <div class="row margin20 margin20bottom" v-if="meldingenTable.tabledata.length === 0">
            <div class="col-md-12">
              <span v-html="translation(4829)"></span>
            </div>
          </div>
          <XVtableflex
            :tablesetting="meldingenTable.tablesetting"
            :tablecolumnsetting="meldingenTable.tablecolumnsetting"
            :tabledata="meldingenTable.tabledata"
            :rowvisible="meldingenTable.rowvisible"
            v-on:sortXVTable="XVTablesort"
            :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
            :filterfunc="(tabledata) => tabledata"
            @ScrollBottom="getNewMeldingen"
            :usePortalHeader="true"
            :formatDateRelative="true"
            :messageId="messageId"
          >
            <!-- <template slot="XVTableHeader">

            </template>-->
            <template slot="tblMessageDocumentID">
              <span></span>
            </template>
            <template slot="tblMessageDateTimeRead" slot-scope="dr">
              <span :ref="'msg-'" v-if="!viewProfAsAdmin" style="margin-right: 5px">
                <XVcheckbox
                  @click="selectMelding(dr.row.tblMessageID, !dr.row.tableRowState.selected)"
                  :id="'checkboxMleding' + dr.row.tblMessageDocumentID"
                  :value="dr.row.tableRowState.selected"
                />
              </span>
              <span @click="openDetail(dr)" class="pointer">
                <font-awesome-icon
                  style="font-size: 18px"
                  v-if="dr.row.tableRowState.setRead !== true"
                  :icon="['far', 'envelope']"
                  size="2x"
                  class="align-middle"
                />
                <font-awesome-icon
                  style="font-size: 18px; color: lightgrey"
                  v-if="dr.row.tableRowState.setRead === true"
                  :icon="['far', 'envelope-open']"
                  class="align-middle"
                />
              </span>
              <span @click="openDetail(dr)" class="pointer">
                <font-awesome-icon
                  style="font-size: 16px"
                  v-if="dr.row.tblMessageDocumentID !== 0"
                  :icon="['fas', 'paperclip']"
                  class="align-middle"
                />
              </span>
              <span @click="openDetail(dr)" class="pointer" v-if="dr.row.tblMessagePrio === 1">
                <font-awesome-icon style="font-size: 16px; color: red" :icon="['fas', 'exclamation-circle']" />
              </span>
            </template>
            <template slot="tblMessageDateTimeCreated" slot-scope="dr">
              <span
                class="meldingenDateTimeCreatedSpan pointer"
                :class="{ mailunread: dr.row.tableRowState.setRead !== true }"
                @click="openDetail(dr)"
                >{{ dr.row.tblMessageDateTimeCreated }}</span
              >
            </template>
            <template slot="tblMessageCreatedBy" slot-scope="dr">
              <span
                class="meldingenCreatedBySpan pointer"
                @click="openDetail(dr)"
                :class="{
                  mailunread: dr.row.tableRowState.setRead !== true,
                  wrapped: !dr.row.tableRowState.rowVisible,
                }"
                v-html="dr.row.tblMessageCreatedBy"
                :title="titleMsgCreatedBy(dr.row.tblMessageCreatedBy)"
              ></span>
            </template>

            <template slot="tblMessageSubject" slot-scope="dr">
              <span
                class="meldingenSubjectSpan pointer"
                @click="openDetail(dr)"
                :class="{
                  mailunread: dr.row.tableRowState.setRead !== true,
                  wrapped: !dr.row.tableRowState.rowVisible,
                }"
                v-html="dr.row.tblMessageSubject"
                :title="titleMsgSubject(dr.row.tblMessageSubject)"
              ></span>
            </template>
            <template slot="detailrow" slot-scope="dr">
              <div class="MessageDetail" v-if="dr.row.tableRowState.tblMessageDetails">
                <div
                  v-if="dr.row.tableRowState.tblMessageDetails.downloadlinks.length !== 0"
                  class="linkblockmelding bckcol-info-lighter"
                >
                  <div v-for="(file, index) in dr.row.tableRowState.tblMessageDetails.downloadlinks" :key="index">
                    <font-awesome-icon :icon="['fas', 'paperclip']" style="font-size: 16px" />
                    <a :href="getDownloadUrl(file.uploadFileID, file.fileToken)" target="_blank">{{ file.filename }}</a>
                  </div>
                </div>

                <div
                  class="linkblockmelding bckcol-info-lighter"
                  v-html="dr.row.tableRowState.tblMessageDetails.tblMessageDescription"
                ></div>
                <div
                  class="linkblockmelding bckcol-info-lighter"
                  v-if="dr.row.tableRowState.tblMessageDetails.tblMessageLinkUrl !== null"
                >
                  <font-awesome-icon :icon="['far', 'link']" />
                  {{ translation(4698) }}
                  <a
                    v-if="!isVueUrl(dr.row.tableRowState.tblMessageDetails.tblMessageLinkUrl)"
                    :href="dr.row.tableRowState.tblMessageDetails.tblMessageLinkUrl"
                    @click="
                      dr.row.tableRowState.tblMessageDetails.tblMessageLinkUrl.indexOf('javascript') === -1
                        ? startwaiter()
                        : null
                    "
                    >{{ translation(4699) }}</a
                  >
                  <router-link
                    v-if="isVueUrl(dr.row.tableRowState.tblMessageDetails.tblMessageLinkUrl)"
                    :to="dr.row.tableRowState.tblMessageDetails.tblMessageLinkUrl"
                    >{{ translation(4699) }}</router-link
                  >
                  {{ translation(15549) }}
                </div>
              </div>
            </template>
          </XVtableflex>
        </div>
        <footer class="XVtableVirtalScroll-footer bckcol-primary"></footer>
      </main>
    </div>
  </div>
</template>

<script>
// https://pe.xaurum.nl/peapp/prof/meldingen
// https://pe.xaurum.nl/peapp/edu/meldingen
// https://pe.xaurum.nl/peapp/beheer/meldingen
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { FAMixin, util } from 'pevueglobal'

export default {
  data: function () {
    return {}
  },
  async mounted() {
    const activeProfOrg = Number(util.UgetCookie('pe_activeProfOrg'))
    const { id, msgId, legacy } = this.$route.query

    if (activeProfOrg === 43 && !legacy) {
      if (id) {
        window.location = `/fe/allroles/messages/${id}`
      } else if (msgId) {
        window.location = `/fe/allroles/messages?msgId=${msgId}`
      } else {
        window.location = '/fe/allroles/messages'
      }
    }

    await this.setSessionFilterState()

    if (this.$route.query.msgId) {
      const msgId = this.$route.query.msgId
      await this.setMessageId(msgId)
    }
    const queryParams = this.$route.query
    delete queryParams.msgId
    this.setUrlQueryParams(queryParams)

    await this.getMeldingen()

    if (this.messageId) {
      this.openMessageDeeplink(Number(this.messageId))
    }
    this.stopLoading()
  },
  computed: {
    ...mapGetters('SPE203Meldingen', [
      'meldingenTable',
      'graphdata',
      'inboxCount',
      'archiveCount',
      'archiveToggle',
      'search',
      'isDetailOpen',
      'waiter',
      'viewProfAsAdmin',
      'profPersonId',
      'profPersonName',
      'showLinkActiviteiten',
      'showLinkProfDetail',
      'showLinkMutatie',
      'showLinkStatusoverzicht',
      'showLinkMSF',
      'adminWelcomeText',
      'messageId',
    ]),
    ...mapGetters(['fixedContainerHeight']),
  },
  methods: {
    ...mapActions('SPE203Meldingen', [
      'setMessageId',
      'setUrlQueryParams',
      'getMeldingen',
      'getNewMeldingen',
      'getInboxCount',
      'getSpe203GetGraphs',
      'getGraphUrl',
      'getMeldingDetail',
      'setToggleArchive',
      'changeSortMeldingen',
      'setMeldingenSearch',
      'setReadUnreadMeldingen',
      'setArchiveMeldingen',
      'setSessionFilterState',
    ]),
    ...mapMutations('SPE203Meldingen', [
      'XVTablesort',
      'XVtablecolumnsettingchanged',
      'XVtableSetRowStateProperty',
      'setSearch',
      'togglewaiter',
    ]),
    titleMsgCreatedBy(text) {
      return text.replace(/<[^>]*>?/gm, '')
    },
    titleMsgSubject(text) {
      return text.replace(/<[^>]*>?/gm, '')
    },
    async openDetail(tablerow) {
      let editmodus = tablerow.row.tableRowState.editModus
      if (!editmodus) {
        this.startLoading({ showmessage: false, disablepage: false })
        await this.getMeldingDetail(tablerow.row.tblMessageID)
        this.stopLoading()
      }

      let selectedMessage = this.meldingenTable.tabledata.find((row) => row.tableRowState.rowVisible === true)
      if (selectedMessage && tablerow.row.tblMessageID !== selectedMessage.tblMessageID) {
        this.XVtableSetRowStateProperty({
          index: selectedMessage.tableRowState.storeTableindex,
          stateProperty: 'rowVisible',
          statePropertyValue: false,
        })
        this.XVtableSetRowStateProperty({
          index: selectedMessage.tableRowState.storeTableindex,
          stateProperty: 'editModus',
          statePropertyValue: false,
        })
      }

      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'rowVisible',
        statePropertyValue: !editmodus,
      })
      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'editModus',
        statePropertyValue: !editmodus,
      })
    },
    selectMelding(tblMessageID, selected) {
      let selectedMessage = this.meldingenTable.tabledata.find((row) => row.tblMessageID === tblMessageID)

      this.XVtableSetRowStateProperty({
        index: selectedMessage.tableRowState.storeTableindex,
        stateProperty: 'selected',
        statePropertyValue: selected,
      })
    },
    selectAllMeldingen() {
      this.meldingenTable.tabledata.forEach((row) => {
        this.XVtableSetRowStateProperty({
          index: row.tableRowState.storeTableindex,
          stateProperty: 'selected',
          statePropertyValue: true,
        })
      })
    },
    deSelectAllMeldingen() {
      this.meldingenTable.tabledata.forEach((row) => {
        this.XVtableSetRowStateProperty({
          index: row.tableRowState.storeTableindex,
          stateProperty: 'selected',
          statePropertyValue: false,
        })
      })
    },
    selectGelezenMeldingen() {
      this.meldingenTable.tabledata.forEach((row) => {
        if (row.tableRowState.setRead) {
          this.XVtableSetRowStateProperty({
            index: row.tableRowState.storeTableindex,
            stateProperty: 'selected',
            statePropertyValue: true,
          })
        } else {
          this.XVtableSetRowStateProperty({
            index: row.tableRowState.storeTableindex,
            stateProperty: 'selected',
            statePropertyValue: false,
          })
        }
      })
    },
    graphClick: function (graphClickinfo) {
      const setPersonID =
        this.$route.params.personid !== 'null' ? Number(this.$route.params.personid) : Number(this.profPersonId)
      const graphGetUrlinputApi = {
        pagename: 'SPE310_BH_HoofdschermV2.aspx',
        clientid: '',
        filters: [
          {
            key: 'personID',
            value: setPersonID,
          },
          {
            key: 'msfID',
            value: Number(this.$route.params.MsfID),
          },
          {
            key: 'tblMultiSourceFeedbackID',
            value: Number(this.$route.params.MsfID),
          },
        ],
        graphIDForUrl: graphClickinfo.graphID,
        defaultfilter: '',
      }
      this.getGraphUrl({ graphGetUrlinputApi: graphGetUrlinputApi, graphShowInPopup: graphClickinfo.graphShowInPopup })
    },
    selectOnGelezenMeldingen() {
      this.meldingenTable.tabledata.forEach((row) => {
        if (!row.tableRowState.setRead) {
          this.XVtableSetRowStateProperty({
            index: row.tableRowState.storeTableindex,
            stateProperty: 'selected',
            statePropertyValue: true,
          })
        } else {
          this.XVtableSetRowStateProperty({
            index: row.tableRowState.storeTableindex,
            stateProperty: 'selected',
            statePropertyValue: false,
          })
        }
      })
    },
    startwaiter() {
      this.togglewaiter(true)
    },
    isVueUrl(url) {
      var path = url.substring(0, url.indexOf('?'))
      return path.indexOf('peapp/') !== -1
    },
    async openMessageDeeplink(messageId) {
      let selectedMessage = this.meldingenTable.tabledata.find((row) => row.tblMessageID === messageId)

      if (selectedMessage) {
        await this.getMeldingDetail(messageId)
        this.XVtableSetRowStateProperty({
          index: selectedMessage.tableRowState.storeTableindex,
          stateProperty: 'rowVisible',
          statePropertyValue: true,
        })
        this.XVtableSetRowStateProperty({
          index: selectedMessage.tableRowState.storeTableindex,
          stateProperty: 'editModus',
          statePropertyValue: true,
        })
      }
      // messages id back to default. other wise when scrolling and getting more data user will scroll back to this messageId again.
      this.setMessageId('')
    },
  },
  mixins: [FAMixin],
}
</script>

<style></style>
